import React from 'react';
import { useTranslation } from 'react-i18next';
import logoicon from '../images/tuutuum-logo-icon.png';
import LanguageSwitcher from '../components/LanguageSwitcher';

const CreateBearerStep4_Sex = ({onNext, onPrevious, sex, setSex}) => {
	const { t } = useTranslation();

	return (<>
		<div className="flex items-center justify-center h-full w-full bg-gradient-to-r from-cyan-100 to-green-100">
			<div className="flex flex-col neumorp items-center justify-center space-y-5 bg-white px-6 py-10 sm:p-10 rounded-lg shadow-lg w-full max-w-2xl">
				{/* Logo and Language Switcher */}
				<div className="flex items-center justify-between w-full">
					<img src={logoicon} alt="Tuutuum Logo" className="block h-7 w-auto"/>
					<LanguageSwitcher />
				</div>
				
				<div className="text-center px-2">
					<h2 className="text-2xl leading-tight mb-1">
						{t("biological_sex_question")}
					</h2>
					<p className="text-base text-gray-600 mt-1">
						{t("can_update_anytime")}
					</p>
				</div>

				{/* Sex select */}
				<div className="w-full">
					<label htmlFor="sex" className="block text-sm font-medium leading-6 text-gray-900 mb-2">
					{t("biological_sex")}
					</label>
					<select
						id="sex"
						value={sex}
						onChange={(e) => setSex(e.target.value)}
						className="block w-full rounded-md border-0 py-3 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-cyan-600 sm:text-sm sm:leading-6"
					>
						<option value="unspecified">{t("sex_unspecified")}</option>
						<option value="female">{t("sex_female")}</option>
						<option value="male">{t("sex_male")}</option>
					</select>
				</div>

				<div className="flex flex-nowrap w-full gap-4 justify-between pt-4">
					{/* Previous Button */}
					<button
						onClick={onPrevious}
						className="btn-main btn-main:hover text-white px-3 py-1 w-auto rounded-md sm:leading-6 text-center font-semibold text-sm transition ease-in-out hover:scale-105"
					>
						{t("previous")}
					</button>
					{/* Next Button */}
					<button
						onClick={onNext}
						className="btn-main btn-main:hover text-white px-3 py-1 w-auto rounded-md sm:leading-6 text-center font-semibold text-sm transition ease-in-out hover:scale-105"
					>
						{t("next")}
					</button>
				</div>
			</div>
		</div>
	</>);
}

export default CreateBearerStep4_Sex;
